import React from "react";
import AsyncSelect from "react-select/async";
import { debounce } from "utils";
import "./AutoSuggest.scss";
//
import { withStyles } from "@material-ui/core";
//
import {
    Control,
    MenuList,
    Menu,
    NoOptionsMessage,
    Option,
    SingleValue,
    ValueContainer,
    ClearIndicator,
    DropdownIndicator,
    NoComponent,
    IndicatorsContainer,
} from "containers/components/autoSuggest/AutoSuggestComponents";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    input: {
        display: "flex",
        padding: "16px 12px 4px",
        transition: "opacity .15s ease-in-out",
        height: "36px",
    },
    inputDisabled: {
        opacity: "0.5",
    },
    valueContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        overflow: "hidden",
    },
    indicatorsContainer: {
        display: "flex",
        cursor: "pointer",
    },
    indicator: {
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        padding: "0px",
        marginLeft: "4px",
        color: theme.palette.background.default,
        height: "20px",
    },
    chip: {
        margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
    },
    chipFocused: {},
    noOptionsMessage: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    singleValue: {
        fontSize: 14,
        overflow: "hidden",
        maxHeight: "100%",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    menuList: {
        maxHeight: "200px !important",
    },
    paper: {
        fontSize: 14,
        position: "absolute",
        zIndex: 5,
        marginTop: theme.spacing(0),
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing(2),
    },
});

const AutoSuggest = (props) => {
    const {
        classes,
        theme,
        disabled,
        error,
        arg,
        label,
        helperText,
        debounceTimeout,
        optionIdentifier,
        renderOption,
        value,
        onBlur,
        onChange,
    } = props;

    const selectStyles = {
        input: (base) => ({
            ...base,
            color: theme.palette.text.primary,
            "& input": {
                font: "inherit",
            },
        }),
    };

    const debouncedFetch = debounce(
        (value, callback) => {
            props.fetchOptions
                .apply(this, [value].concat([arg]))
                .then((suggestions) => callback(suggestions.map(renderOption)))
                .catch((e) => callback([]));
        },
        !!debounceTimeout ? debounceTimeout : 0
    );

    const loadOptions = (value, callback) => {
        debouncedFetch(value, callback);
    };

    const handleChange = (value) => {
        onChange(value && value.value);
    };

    return (
        <div className={classes.root}>
            <AsyncSelect
                key={arg}
                label={label}
                helperText={helperText}
                classes={classes}
                styles={selectStyles}
                optionIdentifier={optionIdentifier}
                components={{
                    Control,
                    MenuList,
                    Menu,
                    NoOptionsMessage,
                    Option,
                    SingleValue,
                    ValueContainer,
                    ClearIndicator: ClearIndicator,
                    DropdownIndicator: DropdownIndicator,
                    IndicatorSeparator: NoComponent,
                    IndicatorsContainer,
                }}
                value={(value || value === 0) && renderOption(value)}
                defaultOptions
                loadOptions={loadOptions}
                onChange={handleChange}
                onBlur={onBlur}
                placeholder=""
                isClearable
                isDisabled={disabled}
                error={error}
            />
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(AutoSuggest);
